import { globalRawServicesData } from "@/constants/globalRawServicesData/globalRawServicesData";
import { TInquiriesDetailsData } from "@/interfaces";

export function isBouncedCheckInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  const payload = (data as any)?.data;
  const inquiryFlag = (data as any)?.inquery?.flag;
  const result = payload?.data;
  const fullResult = payload?.result;
  const nestedFullResult = payload?.data?.result;
  const bouncedCheckInquiryIds = [
    globalRawServicesData.Bounced_Check.api.apiId,
    81,
    83,
  ];

  if (inquiryFlag === "active_loans") {
    return false;
  }

  return (
    inquiryFlag === "returned_check" ||
    inquiryFlag === "returned_check_details" ||
    inquiryFlag === "back_cheques" ||
    bouncedCheckInquiryIds.includes(Number(data?.inquery_id)) ||
    Boolean(
      result?.count !== undefined ||
      result?.sumAmount !== undefined ||
      result?.sumBouncedAmount !== undefined ||
      fullResult?.chequeList ||
      nestedFullResult?.chequeList,
    )
  );
}

export function isActiveLoansInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  const payload = (data as any)?.data;
  const inquiryFlag = (data as any)?.inquery?.flag;
  const inquiryData = payload?.data;

  return Boolean(
    inquiryFlag === "active_loans" ||
    Number(data?.inquery_id) === globalRawServicesData.Active_Loans.api.apiId ||
    inquiryData?.loans ||
    inquiryData?.facilities ||
    inquiryData?.items,
  );
}

export function isIbanInquiryDetailsComponent(data?: TInquiriesDetailsData) {
  return data?.inquery_id === globalRawServicesData.Iban_Inquiry.api.apiId;
}

export function isCardsInquiryDetailsComponent(data?: TInquiriesDetailsData) {
  return data?.inquery_id === globalRawServicesData.Card_Inquiry.api.apiId;
}

export function isCardToDepositInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Card_To_Account.api.apiId;
}

export function isCardToIbanInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Card_To_Iban.api.apiId;
}

export function isCompanyInfoInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Company_Information_Inquiry.api.apiId
  );
}

export function isTaxRecordsInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  const payload = (data as any)?.data;
  const inquiryFlag = (data as any)?.inquery?.flag;
  const inquiryData = payload?.data ?? payload;

  return Boolean(
    inquiryFlag === "tax_records" ||
    Number(data?.inquery_id) ===
      globalRawServicesData.Tax_Records_Inquiry.api.apiId ||
    Array.isArray(inquiryData?.records),
  );
}

export function isCompanyMembersInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Company_Members_Inquiry.api.apiId
  );
}

export function isCompanyLicensesInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Company_Licenses_Inquiry.api.apiId
  );
}

export function isCompanyParentsInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Company_Parent_Inquiry.api.apiId
  );
}

export function isCorporateIdentityInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Corporation_Identity_Inquiry.api.apiId
  );
}

export function isCompanyChildrenInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Company_Children_Inquiry.api.apiId
  );
}

export function isDepositToIbanInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Account_To_Iban.api.apiId;
}

export function isMilitaryServiceInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Military_Service_Status.api.apiId
  );
}

export function isMilitaryCardInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Military_Card_Status.api.apiId
  );
}

export function isEducationalExemptionInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Educational_Exemption.api.apiId
  );
}

export function isPostalCodeInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Postal_Code_Inquiry.api.apiId
  );
}

export function isFinesInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Fines.api.apiId;
}

export function isVehicleTransferTaxDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  const payload = (data as any)?.data?.data;

  return Boolean(
    payload?.obj &&
    payload?.taxes &&
    (Array.isArray(payload.taxes) || payload.taxes.taxId),
  );
}

export function isFreewayTollDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  const payload = (data as any)?.data;
  const inquiryFlag = (data as any)?.inquery?.flag;
  const inquiryData = payload?.data ?? payload;

  return Boolean(
    inquiryFlag === "freeway_toll" ||
    Number(data?.inquery_id) === globalRawServicesData.Freeway_Toll.api.apiId ||
      inquiryData?.result?.bills ||
      inquiryData?.result?.totalAmount !== undefined,
  );
}

export function isVehicleInfoDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  const payload = (data as any)?.data;
  const inquiryFlag = (data as any)?.inquery?.flag;
  const inquiryData = payload?.data ?? payload;

  return Boolean(
    inquiryFlag === "vehicle_info" ||
    Number(data?.inquery_id) === globalRawServicesData.Vehicle_Info.api.apiId ||
    inquiryData?.engineNumber ||
    inquiryData?.chassisNumber ||
    inquiryData?.vin ||
    inquiryData?.model,
  );
}

export function isThirdPartyInsuranceDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  const payload = (data as any)?.data;
  const inquiryFlag = (data as any)?.inquery?.flag;
  const inquiryData = payload?.data ?? payload;
  const result = inquiryData?.result ?? inquiryData;

  return Boolean(
    inquiryFlag === "tpi" ||
      Number(data?.inquery_id) ===
        globalRawServicesData.Third_Party_Insurance.api.apiId ||
      result?.thirdPolicyCode ||
      result?.companyName ||
      result?.mapVehicleSystemName,
  );
}

export function isMotorcycleFinesInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Motorcycle_Fines.api.apiId;
}

export function isPlateInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Plate_Inquiry.api.apiId;
}

export function isNegativePointsInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Negative_Points.api.apiId;
}

export function isDrivingLicenseStatusInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    (data as any)?.inquery?.flag === "driving_license_status" ||
    Number(data?.inquery_id) ===
      globalRawServicesData.Driving_License_Status.api.apiId
  );
}

export function isPassportStatusInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Passport_Status.api.apiId;
}

export function isSanaInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Sana_Inquiry.api.apiId;
}

export function isIdentityInquiryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Identity_Inquiry.api.apiId;
}

export function isBankValidationDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  const payload = (data as any)?.data;
  const inquiryFlag = (data as any)?.inquery?.flag;
  const result = payload?.data?.result ?? payload?.result;

  return Boolean(
    inquiryFlag === "internal_credit_score" ||
    data?.inquery_id === globalRawServicesData.Bank_Validation.api.apiId ||
    result?.creditScore !== undefined ||
    result?.scoreBreakdown !== undefined,
  );
}

export function isForeignersDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Foreigners_Inquiry.api.apiId
  );
}

export function isFinesPhotoDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Fines_Photo.api.apiId;
}

export function isCarDocumentDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Car_Document_Inquiry.api.apiId
  );
}

export function isRegisterChequeDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Cheque_Inquiry.api.apiId;
}

export function isChequeDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Cheque_V2_Inquiry.api.apiId;
}

export function isChequeTransferChainsDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Transfer_Chain_Inquiry.api.apiId
  );
}

export function isPostalTrackingDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Postal_Tracking_Inquiry.api.apiId
  );
}

export function isCompanyNewspaperDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Company_Newspaper_inquiry.api.apiId
  );
}

export function isElectricityBillDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Electricity_Bill_inquiry.api.apiId
  );
}

export function isElectricityBillInfoDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Electricity_Bill_Info_inquiry.api.apiId
  );
}

export function isGasBillDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return data?.inquery_id === globalRawServicesData.Gas_Bill_inquiry.api.apiId;
}

export function isGasBillInfoDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Gas_Bill_Info_inquiry.api.apiId
  );
}

export function isWaterBillDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Water_Bill_inquiry.api.apiId
  );
}

export function isWaterBillInfoDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Water_Bill_Info_inquiry.api.apiId
  );
}

export function isElectricityHistoryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Electricity_Bill_History_inquiry.api.apiId
  );
}

export function isElectricityImageDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Electricity_Bill_Image_inquiry.api.apiId
  );
}

export function isGasHistoryDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Gas_Bill_History_inquiry.api.apiId
  );
}

export function isPhoneBillDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Phone_Bill_inquiry.api.apiId
  );
}

export function isPhoneBillImageDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Phone_Bill_Image_inquiry.api.apiId
  );
}

export function isMobileMciDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Mobile_Bill_Mci_inquiry.api.apiId
  );
}

export function isMobileMtnDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id === globalRawServicesData.Mobile_Bill_Mtn_inquiry.api.apiId
  );
}

export function isMobileRightelDetailsComponent(
  data?: TInquiriesDetailsData,
): boolean {
  return (
    data?.inquery_id ===
    globalRawServicesData.Mobile_Bill_Rightel_inquiry.api.apiId
  );
}
